export default __webpack_public_path__ + "static/media/Ballroll_00237.73c01072.png";